const emailTemplate = {
  subject: 'edX Course Assignment Revoked',
  greeting: '',
  body: 'Your Learning Manager has revoked access code {CODE} and it is no longer assigned to your edX account {USER_EMAIL}.',
  closing: `
For any questions, please reach out to your Learning Manager.`,
  files: [],
};

export default emailTemplate;
